import type {Errors} from '../../errors/errors';

import {
  EventPageContentDocument,
  EventRegistrationFormDeregisterMutationVariables,
  useEventRegistrationFormDeregisterMutation,
} from './__generated__/Event.graphql';
import FormSubmissionError from '../../errors/FormSubmissionError';
import translateOrFallback from '../../i18n/translateOrFallback';

import {GraphQLError} from 'graphql';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

export type DoMutation = (
  data: EventRegistrationFormDeregisterMutationVariables,
) => Promise<void>;

export default function useSubmitDeregistration(): DoMutation {
  const [commit] = useEventRegistrationFormDeregisterMutation();
  const {t} = useTranslation();

  return useCallback(
    async (input: EventRegistrationFormDeregisterMutationVariables) => {
      try {
        await commit({
          variables: input,
          refetchQueries: [
            {
              query: EventPageContentDocument,
              variables: {
                id: input.eventID,
              },
            },
          ],
        });
      } catch (err) {
        throw FormSubmissionError.fromGraphQLMutationError<EventRegistrationFormDeregisterMutationVariables>(
          err,
          (error: GraphQLError) => {
            const fieldErrors: Errors<EventRegistrationFormDeregisterMutationVariables> =
              {};
            const formErrors: string[] = [];
            if (error.path?.[0] === 'viewerDeregisterGroupSession') {
              formErrors.push(
                translateOrFallback(
                  error.message,
                  t('form.unknown-form-submission-error'),
                ),
              );
            }
            return [fieldErrors, formErrors];
          },
        );
      }
    },
    [commit],
  );
}
